import React, { useEffect } from 'react';
import { NextPage } from 'next';

import SubHeader from 'components/common/SubHeader';
import { SubHeaderOptions } from 'constants/index';
import { AxiosResponse } from 'axios';
import { GetRetailAPI } from 'api/space';
import { spaceActions } from 'store/space';

import RetailDetailService from 'components/retail/_detail';
import { useRouter } from 'next/router';
import { ERROR_500 } from 'constants/message';

interface IProps {
  error?: boolean;
}

const RetailDetail: NextPage<IProps> = ({ error }: IProps) => {
  const router = useRouter();

  useEffect(() => {
    if (error) {
      alert(ERROR_500);
      router.push('/');
    }
  }, [error, router]);

  if (error) {
    return null;
  }

  return (
    <>
      <SubHeader options={SubHeaderOptions} selected="리테일" />
      <RetailDetailService />
    </>
  );
};

RetailDetail.getInitialProps = async ({ store, query }) => {
  const { id } = query;

  const retail: AxiosResponse = await GetRetailAPI(id);

  if (retail.status >= 400) {
    return {
      error: true,
    };
  }

  store.dispatch(spaceActions.getRetail(retail.data));

  return {
    error: false,
  };
};

export default RetailDetail;
